import React, { useState } from "react"
import { Button } from "@mui/material"
import { Modal } from "antd"
import DocumentFiles, { EntityType } from "components/Common/DocumentFiles"

export const DocumentFilesDialog = ({ rowData, mainProps }) => {
  const [open, setOpen] = useState(false)
  const [reloadKey, setReloadKey] = useState(0)

  const handleOpen = () => {
    setReloadKey((prev) => prev + 1)
    setOpen(true)
  }

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={handleOpen}
      >
        مهروامضاء
      </Button>

      <Modal
        open={open}
        title={`مدیریت مستندات: ${rowData.fullName} - شرکت ${rowData.packageCompanyName}`}
        onCancel={() => setOpen(false)}
        footer={null}
        width={900}
      >
        <div style={{ padding: "20px 0" }}>
          <DocumentFiles
            key={reloadKey}
            entityId={rowData.id}
            entityType={EntityType.PackageInstaller}
            maxFiles={2}
            maxFileSize={1}
          />
        </div>
      </Modal>
    </>
  )
}
